<template>
  <div>
    <div v-for="current in menu" :key="current.text">
      <v-list-group
        v-if="current.items"
        :prepend-icon="current.icon"
        v-model="current.active"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-title
            :id="getItemId(current, 'li-menu')"
            :class="{ 'font-weight-black' : current.active }"
          >
            {{ current.text }}
          </v-list-item-title>
        </template>

        <v-list-item
          v-for="item in filtered(current.items)"
          :key="item.text"
          :to="item.route"
          :id="getItemId(item, 'li-anchor')"
        >
          <v-list-item-title
            v-if="hasPermissions(item)"
            :class="{ 'font-weight-black' : item.route.name === $route.name }"
          >
            {{ item.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-item-group v-else color="primary">
        <v-list-item :id="getItemId(current, 'li-anchor')" :to="current.route">
          <v-list-item-icon>
            <v-icon>{{ current.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title
            color="primary"
            :class="{ 'font-weight-black' : current.route.name === $route.name }"
          >
            {{ current.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnchorRouterMenu',
  props: {
    items: {
      type: Array,
      required: true,
    },
    user: {
      type: Object,
      default: () => ({ permissions: [] }),
    },
  },
  computed: {
    menu() {
      return this.items
        .filter(item => this.hasPermissions(item))
        .map(item => {
          if (!item.items) { return item; }

          const tmp = this.$utils.deepCopy(item);
          tmp.active = this.isActive(tmp);
          return tmp;
        });
    },
  },
  methods: {
    hasPermissions(item) {
      return item.permissions && item.permissions.length !== 0 ?
        item.permissions.some(permission => this.user.permissions.includes(permission)) :
        true;
    },
    filtered(list) {
      return list.filter(item => this.hasPermissions(item));
    },
    getItemId: (item, prefix) => `${prefix}-${item.text.toLowerCase().split(' ').join('-')}`,
    isActive(curr) {
      const currentRouteName = this.$route.name;
      if (curr.items) {
        return curr.items.map(item => item.route.name).some(name => name === currentRouteName);
      }

      return curr.route.name === currentRouteName;
    },
  },
};
</script>
